
// Getters (GET*)
export const GET_FUNCTIONALITY_LIST = 'GET_FUNCTIONALITY_LIST';
export const GET_REGISTER_FUNCTIONALITY_FORM_VISIBILITY = 'GET_REGISTER_FUNCTIONALITY_FORM_VISIBILITY';
export const GET_SELECTED_FUNCTIONALITY = 'GET_SELECTED_FUNCTIONALITY';
export const GET_GROUPED_FUNCTIONALITY_LIST = 'GET_GROUPED_FUNCTIONALITY_LIST';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
export const FETCH_FUNCTIONALITY_LIST = 'FETCH_FUNCTIONALITY_LIST';
export const CREATE_FUNCTIONALITY_LIST = 'CREATE_FUNCTIONALITY_LIST';
export const UPDATE_REGISTER_FUNCTIONALITY_FORM_VISIBILITY = 'UPDATE_REGISTER_FUNCTIONALITY_FORM_VISIBILITY';
export const UPDATE_SELECTED_FUNCTIONALITY = 'UPDATE_SELECTED_FUNCTIONALITY';
export const CREATE_NEW_FUNCTIONALITY = 'CREATE_NEW_FUNCTIONALITY';
export const UPDATE_FUNCTIONALITY_LIST = 'UPDATE_FUNCTIONALITY_LIST';
export const UPDATE_FUNCTIONALITY = 'UPDATE_FUNCTIONALITY';
export const UPDATE_SYSTEM_FUNCTIONALITY = 'UPDATE_SYSTEM_FUNCTIONALITY';
export const FETCH_GROUPED_FUNCTIONALITY_LIST = 'FETCH_GROUPED_FUNCTIONALITY_LIST';

// Mutations (SET*, ADD*, REMOVE*)
export const SET_FUNCTIONALITY_LIST = 'SET_FUNCTIONALITY_LIST';
export const SET_REGISTER_FORM_VISIBILITY = 'SET_REGISTER_FORM_VISIBILITY';
export const SET_SELECTED_FUNCTIONALITY = 'SET_SELECTED_FUNCTIONALITY';
export const ADD_FUNCTIONALITY_TO_LIST = 'ADD_FUNCTIONALITY_TO_LIST';
export const SET_SELECTED_FUNCTIONALITY_SYSTEM = 'SET_SELECTED_FUNCTIONALITY_SYSTEM';
export const SET_GROUPED_FUNCTIONALITY_LIST = 'SET_GROUPED_FUNCTIONALITY_LIST';
